import React from 'react';
import { offerConfig } from '../data/siteConfig';
import { CTABlock } from './Shared';
export const HeroSection = () => {
  return <header id="hero" className="relative overflow-hidden bg-familia-dark" data-id="element-113" data-mp="2hvm6kecsxwec">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-114" data-mp="23vtiyrwknwal" />

      {/* En mobile el CTA sube justo debajo de la imagen para quedar visible sin scrollear */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-5 md:pt-8 pb-12 text-center flex flex-col items-center" data-id="element-115" data-mp="2wjp91drmypye">
        <p className="order-1 text-familia-gold font-semibold text-[12px] sm:text-[13px] uppercase tracking-[0.18em] mb-2 md:mb-3 max-w-2xl leading-relaxed" data-id="element-116" data-mp="30ltzy4qp98hc">
          Vitalidad 360 · Kit imprimible para acompañar adultos mayores en casa
        </p>

        <h1 className="order-2 font-display text-white font-bold text-[30px] sm:text-[40px] md:text-[52px] lg:text-[58px] leading-[1.12] mb-4 md:mb-5 max-w-[20ch] md:max-w-[24ch] text-balance" data-id="element-117" data-mp="2rr604u3w8izx">
          <span className="text-familia-accent" data-id="element-118" data-mp="3kamblzxjkawz">15 minutos al día</span>{' '}
          pueden cambiar por completo la forma en que acompañás a tu mamá o
          papá.
        </h1>

        <p className="order-2 text-[18px] md:text-[21px] leading-relaxed text-familia-onDarkMuted max-w-2xl mb-5 md:mb-7" data-id="element-119" data-mp="2bf840beaq78j">
          Tenés actividades{' '}
          <span className="font-bold text-familia-gold" data-id="element-120" data-mp="2kev7r3uhzp4r">
            listas para elegir, imprimir y compartir
          </span>
          ,{' '}
          <span className="font-semibold text-white underline decoration-familia-accent decoration-2 underline-offset-4" data-id="element-121" data-mp="2z26n7gtsvta5">
            sin equipos costosos ni horas de preparación
          </span>
          .
        </p>

        <div className="order-3 relative w-[70%] sm:w-full sm:max-w-[420px] md:max-w-[500px] mb-4 md:mb-6 aspect-square" data-id="element-122" data-mp="3823e7p3nx48d">
          <img src="https://cdn.magicpatterns.com/uploads/xfBQ45cbs8uaXH9nFDdf4y/mockup_vitalidad360_bundle_1x1.webp" alt="Vitalidad 360 — Sistema maestro para adultos mayores con cuadernillos, planillas y versión digital" width="500" height="500" loading="eager" fetchPriority="high" decoding="async" className="relative z-10 w-full h-full object-cover rounded-2xl border border-familia-darkBorder" data-id="element-123" data-mp="1dq6jnn9xbi93" />
        </div>

        <div className="order-5 md:order-4 max-w-2xl mt-6 md:mt-0" data-id="element-124" data-mp="3iqzgren6v2lz">
          <p className="text-body font-bold text-white md:mb-7" data-id="element-125" data-mp="3itveb1v4jp9w">
            Pagás y te llega al mail en minutos. Hoy mismo ya podés tener la
            primera actividad sobre la mesa.
          </p>
        </div>

        <CTABlock href="#precio-lanzamiento" tone="dark" className="order-4 md:order-5" buttonClassName="md:px-10" data-id="element-126" data-mp="lw67eegdye6">
          QUIERO EL KIT — LO RECIBO YA
        </CTABlock>

        <div className="order-6 mt-5 flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-[14px] sm:text-[15px] text-familia-onDarkMuted" data-id="element-127" data-mp="5epbq4hqxarb">
          <span data-id="element-128" data-mp="ee2c87nw6ozw">🔒 Mercado Pago (tarjeta, débito o dinero en cuenta)</span>
          <span data-id="element-129" data-mp="jc467nmuw8q5">🛡️ {offerConfig.guaranteeDays} días de garantía</span>
          <span data-id="element-130" data-mp="jaaxm2sonefi">⚡ Descarga inmediata</span>
        </div>
      </div>
    </header>;
};